export enum DisputeReason {
  MIB_DISPUTE = 'MIB_DISPUTE',
  MILLIMAN_DISPUTE = 'MILLIMAN_DISPUTE',
  TU_DISPUTE = 'TU_DISPUTE',
  MVR_DISPUTE = 'MVR_DISPUTE',
  EXAMONE_DISPUTE = 'EXAMONE_DISPUTE',
  QA_INTERNAL_ASSESSMENT = 'QA_INTERNAL_ASSESSMENT',
  OTHER = 'OTHER',
}

export const DisputeReasonDisplayMap: Record<DisputeReason, string> = {
  [DisputeReason.MIB_DISPUTE]: 'MIB Dispute',
  [DisputeReason.MILLIMAN_DISPUTE]: 'Milliman Dispute',
  [DisputeReason.TU_DISPUTE]: 'TU Dispute',
  [DisputeReason.MVR_DISPUTE]: 'MVR Dispute',
  [DisputeReason.EXAMONE_DISPUTE]: 'ExamOne Dispute',
  [DisputeReason.QA_INTERNAL_ASSESSMENT]: 'QA Internal Assessment',
  [DisputeReason.OTHER]: 'Other',
};
